import { getAccessToken } from "./APIConnector";

export async function updateSurvey(surveyID, body) {
    const baseUrl = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");
    const token = await getAccessToken();
    if (!token) {
        const err = new Error("Not authenticated");
        err.status = 401;
        throw err;
    }
    body.surveyID = 1;
    const res = await fetch(`${baseUrl}/surveys/${surveyID}/`, {
        method: "PATCH",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify(body),
    });
    let data;
    try {
        data = await res.json();
    } catch {
        data = null;
    }
    //
    if (!res.ok) {
        const message = (data && data.detail) || res.statusText || "Failed to update survey";
        const err = new Error(message);
        err.status = res.status;
        err.data = data;
        throw err;
    }
}

